import { render, staticRenderFns } from "./CommunicationsList.vue?vue&type=template&id=d1c4e5b0"
import script from "./CommunicationsList.vue?vue&type=script&lang=js"
export * from "./CommunicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports